import { render, staticRenderFns } from "./WorkspaceMember.vue?vue&type=template&id=80a38906&scoped=true"
import script from "./WorkspaceMember.vue?vue&type=script&lang=js"
export * from "./WorkspaceMember.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMember.vue?vue&type=style&index=0&id=80a38906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a38906",
  null
  
)

export default component.exports